import { keyframes } from 'styled-components';

export const FadeOut = keyframes`
  0% {
    transform: 1;
  }
  100% {
    opacity: 0;
  }
`;
